export enum KnmErknmStatusCodesEnum {
  /** В процессе заполнения */
  FILL_IN_PROCESS = 'FILL_IN_PROCESS',
  /** Готово к согласованию */
  READY_FOR_APPROVE = 'READY_FOR_APPROVE',
  /** На согласовании */
  APPROVING = 'APPROVING',
  /** Не согласована */
  NOT_APPROVE = 'NOT_APPROVE',
  /** Исключена */
  REJECTED = 'REJECTED',
  /** Есть замечания */
  COMMENTS_EXIST = 'COMMENTS_EXIST',
  /** Исключение обжаловано */
  REJECT_APPEALED = 'REJECT_APPEALED',
  /** Решение обжаловано */
  DECISION_APPEALED = 'DECISION_APPEALED',
  /** Ожидает проведения */
  TYPE_WAITING_CARRY_OUT = 'TYPE_WAITING_CARRY_OUT',
  /** Ожидает завершения */
  TYPE_CARRIED_OUT = 'TYPE_CARRIED_OUT',
  /** Завершено */
  TYPE_COMPLETED = 'TYPE_COMPLETED',
  TYPE_DISAPPROVED = 'TYPE_DISAPPROVED',
  /** Не может быть проведено */
  TYPE_CANT_BE_CARRY_OUT = 'TYPE_CANT_BE_CARRY_OUT',
  REJECT = 'REJECT',
  /** Предостережение объявлено */
  REMARK = 'REMARK',
  /** Есть возражение */
  APPEALED = 'APPEALED',
  /** Удалено */
  TYPE_DELETED = 'TYPE_DELETED',
  /** Обжаловано */
  TYPE_APPEALED = 'TYPE_APPEALED',
  /** Отменено */
  TYPE_CANCELED = 'TYPE_CANCELED',
}
